import React from 'react';
import { Box, Card, Fade, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { LoadingStatuses } from '@/constants/constants';
import { useAppSelector } from '@/redux/hooks';
import { selectInventoryIsLoading, selectInventory, selectInventoryStatus } from '@/redux/selectors/orderPlacementSelectors';
import Spinner from '../../_common/Spinner';
import InventoryList from '../../TitleDetail/TitleDetailInventory/InventoryList';
import NoInventory from '../../TitleDetail/TitleDetailInventory/NoInventory';
import ErrorWithRetry from '../../_common/ErrorWithRetry';
import PackagingInventoryList from '@/components/TitleDetail/TitleDetailInventory/PackagingInventoryList';
import { InventoryFileEntity } from '@/redux/slices/slice_types';

type OPInventoryProps = {
  loading: boolean;
  isPackagingInventory: boolean;
  loadInventory: () => void;
  fileType?: string;
  onClickFile?: (file: InventoryFileEntity) => void;
};

const OPInventory = ({ loadInventory, loading, isPackagingInventory, fileType, onClickFile }: OPInventoryProps) => {
  const inventory = useAppSelector(selectInventory);
  const inventoryStatus = useAppSelector(selectInventoryStatus);
  const loadingInventory = useAppSelector(selectInventoryIsLoading);

  if (loading || loadingInventory)
    return (
      <Fade in timeout={400}>
        <Card elevation={0} sx={{ mt: 2, py: 5 }}>
          <LoadingSpinnerBox>
            <Spinner contained />
            <Typography variant="subtitle2" sx={{ mt: 3, opacity: 0.8 }} align="center">
              Retrieving Inventory
            </Typography>
          </LoadingSpinnerBox>
        </Card>
      </Fade>
    );

  if (!inventory.length) {
    if (inventoryStatus !== LoadingStatuses.rejected) {
      return <NoInventory type="version" />;
    } else {
      return <ErrorWithRetry retryFunc={loadInventory} />;
    }
  }

  return isPackagingInventory ? <PackagingInventoryList /> : <InventoryList onClickFile={onClickFile} filterType={fileType} disableDownloads previewOnly />;
};

export default OPInventory;

const LoadingSpinnerBox = styled(Box)`
  margin-top: 80px;
`;
